export default __webpack_public_path__ + "static/media/plug1.7b9a31da.jpg";